let workspaceController = null;

export function registerWorkspaceController(controller) {
  workspaceController = controller;
}

export function unregisterWorkspaceController() {
  workspaceController = null;
}

export function syncWorkspaceAfterBootstrap(accessInfo) {
  workspaceController?.applyBootstrap?.(accessInfo);
}

export function syncWorkspaceAfterSwitch(accessInfo) {
  workspaceController?.applySwitch?.(accessInfo);
}
